import Vue from 'vue/dist/vue.esm';
import VueAxios from 'vue-axios';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import Meta from 'vue-meta';
import VueLazyImage from 'vue-lazy-images';
import VueImg from 'v-img';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueTippy from 'vue-tippy';
import store from '../src/vuex/stores/public';

import CompanyPage from '../src/views/company-page.vue';
import CandidatePage from '../src/views/candidate-page.vue';
import VacancyPage from '../src/views/vacancy-page.vue';
import ShowCompany from '../src/views/show-company.vue';
import ShowVacancy from '../src/views/show-vacancy.vue';

const options = {
  confirmButtonColor: 'red',
  cancelButtonColor: '#ff7674',
};

require('../src/assets/stylesheet/ckeditor.scss');

// Declare imports in vue
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2, options);
Vue.use(Meta);
Vue.use(VueLazyImage);
Vue.use(VueImg);
Vue.use(VueTippy);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(BootstrapVue);

let token = document.getElementsByName('csrf-token')[0].getAttribute('content');
axios.defaults.headers.common['X-CSRF-Token'] = token;
axios.defaults.headers.common['Accept'] = 'application/json';

document.addEventListener('DOMContentLoaded', () => {
  const vueSharedContent = {
    store,
    axios,
    components: {
      CompanyPage,
      CandidatePage,
      VacancyPage,
      ShowCompany,
      ShowVacancy,
    },
  };

  [
    document.getElementById('company'),
    document.getElementById('candidate'),
    document.getElementById('vacancy'),
    document.getElementById('show-company'),
    document.getElementById('show-vacancy'),
  ].forEach((element) => {
    if (element) {
      new Vue({ ...vueSharedContent }).$mount(element);
    }
  });
});
